module.exports = __webpack_public_path__ + "img/rooticon.f5381040.svg";